import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, searchText: string, ...searchFields: string[]): any {
    // Return original array if no value or search text
    if (!value) return null;
    if (!searchText) return value;

    searchText = searchText.toLowerCase();

    // Filter the array based on the search text and fields
    return value.filter(item => {
      // Check if any of the specified fields contain the search text
      return searchFields.some(field => {
        // Skip if field doesn't exist or is null/undefined
        if (item[field] == null) return false;

        // Convert to string and check if it contains the search text
        return String(item[field]).toLowerCase().indexOf(searchText) > -1;
      });
    });
  }
}